import { render, staticRenderFns } from "./UploadBulkyVoucherSKU.vue?vue&type=template&id=7bb0c9f7&"
import script from "./UploadBulkyVoucherSKU.vue?vue&type=script&lang=ts&"
export * from "./UploadBulkyVoucherSKU.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports